/**
 * @author shreyas.hande on 6/21/18
 *
 */
import root from 'window-or-global';


export default class SessionStorage {
  static isSessionStorageEnabled = () => root.hasOwnProperty('sessionStorage');

  static getItem = key => (
    SessionStorage.isSessionStorageEnabled() ? root.sessionStorage.getItem(key) : null
  );

  static setItem = (key, value) => {
    SessionStorage.isSessionStorageEnabled() && root.sessionStorage.setItem(key, value);
  };

  static removeItem = key => {
    SessionStorage.isSessionStorageEnabled() && root.sessionStorage.removeItem(key);
  };

  static clear = () => {
    SessionStorage.isSessionStorageEnabled() && root.sessionStorage.clear();
  }

}



// WEBPACK FOOTER //
// ../q-jobs/src/utils/SessionStorage/index.js